import { Grid, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { Fragment } from "react";
import type { UserRole } from "../../auth/auth";
import { AssociatedFilesView } from "../../components/associatedFiles/AssociatedFilesView";
import EntityCard from "../../components/entityCard/EntityCard";
import Email from "../../components/links/Email";
import Phone from "../../components/links/Phone";
import type { AdminCustomerListItem } from "../customersApi";

export type Customer = Omit<AdminCustomerListItem, "tags">;

interface Props {
  readonly value: Customer;
  readonly role: UserRole;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
}

export const CustomerCard: FC<Props> = ({ value, role, onClick, onContextMenu }) => {
  const accountManagerName = value.accountManager?.name ?? "";
  const travelPayAccountManagerName = value.travelPay?.accountManager?.name ?? "";
  const taxNo = value.taxNo ? `NIP: ${value.taxNo}` : "";
  return (
    <EntityCard role={role} onClick={onClick} onContextMenu={onContextMenu} rightHandSideComponentExpandable>
      <Grid size={3}>
        <Stack>
          <Typography variant="subtitle1">{value.name}</Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
            }}
          >
            Data ostatniego kontaktu: {value.contactDate}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
            }}
          >
            Data ostatniego spotkania: {value.meetingDate}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
            }}
          >
            Status: {value.status}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
            }}
          >
            Status TravelPay: {value.travelPay?.status}
          </Typography>
        </Stack>
      </Grid>
      <Grid size={9} container spacing={2}>
        <Grid size={12} container spacing={1}>
          <Grid size={3}>
            <Typography>{accountManagerName}</Typography>
            <Typography>{travelPayAccountManagerName}</Typography>
          </Grid>
          <Grid size={3}>
            <Typography>{value.publicContact?.city}</Typography>
            <Typography>{value.publicContact?.voivodeship}</Typography>
            <Typography>{taxNo}</Typography>
          </Grid>
          <Grid size={6} container>
            {(value.contacts ?? []).map((c, index) => (
              <Fragment key={`${c.email ?? ""}-${c.phone ?? ""}-${index}`}>
                <Grid size={6}>{c.email && <Email value={c.email} />}</Grid>
                <Grid size={6}>{c.phone && <Phone value={c.phone} />}</Grid>
              </Fragment>
            ))}
          </Grid>
        </Grid>
        <Grid size={12}>
          <AssociatedFilesView values={value.files} />
        </Grid>
      </Grid>
    </EntityCard>
  );
};
